import React, { useEffect } from "react";
import ButtonRed from "../ButtonRed/ButtonRed";
import FloatingLogoAndButton from "../FloatingLogoAndButton/FloatingLogoAndButton";
import img1 from "../../assets/images/grill-father/GF1.jpg";
import img2 from "../../assets/images/grill-father/GF2.jpg";

export default function GrillPrzyStoleBydgoszcz() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-black text-white min-h-screen flex flex-col items-center px-4 py-10">
      <FloatingLogoAndButton />
      <div className="mb-20"></div>
      {/* HERO */}
      <section className="max-w-4xl text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">
          Grill przy stole Bydgoszcz – Grill Father (koreański grill)
        </h1>
        <p className="text-lg opacity-90">
          Grill Father to nasza autorska wersja koreańskiego grilla (Korean
          BBQ), gdzie goście sami przygotowują mięso przy stole.
        </p>
      </section>

      {/* ZDJĘCIA */}
      <section className="w-full max-w-5xl mb-12">
        <div className="flex flex-col md:flex-row gap-4">
          <img
            src={img1}
            alt="koreański grill Bydgoszcz Whitebull Grill Father"
            loading="lazy"
            className="w-full md:w-1/2 h-80 object-cover"
          />
          <img
            src={img2}
            alt="korean bbq Bydgoszcz grill przy stole Grill Father"
            loading="lazy"
            className="w-full md:w-1/2 h-80 object-cover"
          />
        </div>
      </section>

      {/* OPIS */}
      <section className="max-w-3xl text-center mb-12">
        <h2 className="text-2xl font-semibold mb-4">
          Na czym polega grill przy stole?
        </h2>
        <p className="mb-4 opacity-90">
          To coś więcej niż kolacja. Otrzymujesz wysokiej jakości mięso i sam
          przygotowujesz je na grillu wbudowanym w stół.
        </p>
        <p className="opacity-90">
          To połączenie steakhouse’u, zabawy i wspólnego gotowania – idealne na
          spotkania ze znajomymi lub wyjątkowy wieczór.
        </p>
      </section>

      {/* USP */}
      <section className="max-w-3xl mb-12">
        <h2 className="text-2xl font-semibold mb-6 text-center">
          Dlaczego warto wybrać Grill Father?
        </h2>
        <ul className="space-y-3 text-center opacity-90">
          <li>🔥 sam grillujesz mięso przy stole</li>
          <li>🥩 wysokiej jakości wołowina</li>
          <li>👥 idealne na spotkania i grupy</li>
          <li>🎉 unikalne doświadczenie w Bydgoszczy</li>
        </ul>
      </section>

      {/* CTA */}
      <section className="text-center mb-12">
        <h2 className="text-2xl mb-4">Rezerwacja Grill Father</h2>

        <p className="mb-4 font-semibold">
          ⚠️ Przy rezerwacji online wpisz w uwagach: „Grill Father”
        </p>

        <p className="mb-6 opacity-90">
          lub zarezerwuj telefonicznie, aby mieć pewność dostępności stolika z
          grillem.
        </p>

        <div className="flex flex-col gap-4 items-center">
          <ButtonRed
            text={"Rezerwuj online"}
            type={"outputLink"}
            url={"https://zjedz.my/whitebull-bydgoszcz"}
          />

          <a
            href="tel:+48453293882"
            className="border border-white px-6 py-3 rounded-xl hover:bg-white hover:text-black transition"
          >
            Zadzwoń i zarezerwuj
          </a>
        </div>
      </section>

      {/* FAQ */}
      <section className="max-w-3xl mb-12">
        <h2 className="text-2xl mb-6 text-center">
          FAQ – Grill przy stole Bydgoszcz
        </h2>

        <div className="space-y-6 opacity-90">
          <div>
            <h3 className="font-semibold">Co to jest grill przy stole?</h3>
            <p>
              To forma kolacji, gdzie goście sami grillują mięso na specjalnym
              grillu wbudowanym w stół.
            </p>
          </div>

          <div>
            <h3 className="font-semibold">Czy trzeba umieć grillować?</h3>
            <p>
              Nie – wszystko jest proste i intuicyjne, a obsługa pomaga w razie
              potrzeby.
            </p>
          </div>

          <div>
            <h3 className="font-semibold">Czy to jest koreański grill?</h3>
            <p>
              Tak – Grill Father to doświadczenie inspirowane koreańskim grillem
              (Korean BBQ), gdzie goście samodzielnie grillują mięso przy stole.
            </p>
          </div>
        </div>
      </section>

      {/* LINK BACK */}
      <section className="text-center">
        <a href="/bydgoszcz" className="underline opacity-70">
          ← Powrót do restauracji w Bydgoszczy
        </a>
      </section>
    </div>
  );
}
